import { ICreateGameDeveloperState } from './createDeveloperModalContext';
import { CreateGameDeveloperActionTypes, TCreateGameDeveloperAction } from '../createDeveloperModalActions';

export const createGameDeveloperReducer = (
	state: ICreateGameDeveloperState,
	action: TCreateGameDeveloperAction,
): ICreateGameDeveloperState => {
	switch (action.type) {
		case CreateGameDeveloperActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateGameDeveloperActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateGameDeveloperActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateGameDeveloperActionTypes.RESET_FIELDS:
			return {
				...state,
				name: '',
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
